<template>
  <div class="page-container">
    <PageHeader title="短信注册记录" show-breadcrumb />

    <SearchPanel>
      <el-input v-model.trim="query.phone" placeholder="手机号" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.codeNum" placeholder="验证码" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-select v-model="query.codeStatus" placeholder="状态" clearable size="small">
        <el-option label="已发送" :value="1" />
        <el-option label="已使用" :value="2" />
        <el-option label="已过期" :value="3" />
      </el-select>
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="短信记录列表">
      <el-table :data="list" v-loading="loading" size="small" stripe border>
        <el-table-column type="index" label="序号" width="90" align="center" />
        <el-table-column prop="phone" label="手机号"  />
        <el-table-column prop="codeNum" label="验证码"  />
        <el-table-column prop="codeStatus" label="状态"  align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.codeStatus)" size="mini">{{ statusText(row.codeStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间"  />
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getSysRegisterCodeList } from '@/api/api'

export default {
  name: 'SmsRecord',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      list: [],
      query: { phone: '', codeNum: '', codeStatus: null },
      page: { currentPage: 1, pageSize: 10, total: 0 }
    }
  },
  created () { this.fetchList() },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const res = await getSysRegisterCodeList({ ...this.query, currentPage: this.page.currentPage, pageSize: this.page.pageSize })
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { phone: '', codeNum: '', codeStatus: null }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    statusText (v) { return v === 1 ? '已发送' : v === 2 ? '已使用' : v === 3 ? '已过期' : '未知' },
    statusTagType (v) { return v === 1 ? 'info' : v === 2 ? 'success' : v === 3 ? 'danger' : 'info' }
  }
}
</script>
